import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { ButtonCondensed } from '@companycam/slab-web';

import { useGetLanguages } from 'data/v3/dynamicTranslations';
import { graphQLDatabaseIdIntDecoder } from 'helpers/graphql-utils';
import RecordableTypes from 'constants/recordableTypes';
import CommentListItem from './CommentListItem';

const CommentListWithTranslations = ({
  activityItems,
  fetchingResults,
  canLoadMore,
  loadMore,
  nodeId,
  recordableType,
}) => {
  const commentEntryContainer = useRef();
  const [hasScrolled, setHasScrolled] = useState(false);
  const [languages, setLanguages] = useState({});
  const { data, isFetched, refetch } = useGetLanguages({
    nodeId,
    params: { [`${recordableType}Id`]: graphQLDatabaseIdIntDecoder(nodeId) },
  });

  useEffect(() => {
    if (isFetched && data?.comments) {
      setLanguages(data.comments);
    }
  }, [data, isFetched]);

  useEffect(() => {
    if (commentEntryContainer.current && !fetchingResults && !hasScrolled) {
      const children = commentEntryContainer.current.children;
      const last = children[children.length - 1];
      if (last) {
        commentEntryContainer.current.parentElement.scrollTop = last.offsetTop;
        setHasScrolled(true);
      }
    }
  }, [fetchingResults, hasScrolled, setHasScrolled]);

  useEffect(() => {
    refetch();
  }, [activityItems, refetch]);

  return (
    <div className="comment-scroll-container">
      {canLoadMore ? (
        <ButtonCondensed
          color="primary"
          size="small"
          style={{ marginBottom: 16 }}
          icon={{
            name: 'refresh',
            position: 'before',
          }}
          onClick={(e) => {
            e.preventDefault();
            if (!fetchingResults) {
              loadMore();
            }
          }}
        >
          Load more comments…
        </ButtonCondensed>
      ) : null}
      {activityItems.length > 0 && languages ? (
        <div className="comment-set" ref={commentEntryContainer}>
          {activityItems.map((item) => (
            <CommentListItem key={item.id} item={item} languages={languages} />
          ))}
        </div>
      ) : null}
    </div>
  );
};

CommentListWithTranslations.propTypes = {
  fetchingResults: PropTypes.bool,
  activityItems: PropTypes.array, // Array of CommentFragment, VoiceNoteFragment
  canLoadMore: PropTypes.bool,
  loadMore: PropTypes.func,
  nodeId: PropTypes.string,
  recordableType: PropTypes.oneOf([
    RecordableTypes.PHOTO,
    RecordableTypes.PROJECT,
    RecordableTypes.VIDEO,
  ]),
};

export default CommentListWithTranslations;
